import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  NoticesAnalysisByPeriodQuery,
  NoticesAnalysisByPeriodRequestSchema,
  NoticesSearchRequest,
} from "../../../../generated/app-service-gql/graphql";
import { useGraphQlQuery } from "../../useGraphQlClient";
import { REACT_QUERY_OPTIONS_NEVER_REFETCH } from "../../utils";

export type NoticesAnalysisByPeriodQueryKey = [
  "noticesAnalysisByPeriod",
  NoticesSearchRequest,
  NoticesAnalysisByPeriodRequestSchema,
];

const noticesAnalysisByPeriodQuery = graphql(`
  query noticesAnalysisByPeriod(
    $request: NoticesSearchRequest!
    $byPeriodOptions: NoticesAnalysisByPeriodRequestSchema!
  ) {
    notices(NoticesSearchRequest: $request) {
      totalResults
      analysis {
        overall {
          noticeValues
        }
        byPeriod(NoticesAnalysisByPeriodRequest: $byPeriodOptions) {
          results {
            dateStart
            dateEnd
            noticeCount
            noticeValues
          }
        }
      }
    }
  }
`);

export function useNoticesAnalysisByPeriod(
  searchNoticesRequest: NoticesSearchRequest,
  byPeriodOptions: NoticesAnalysisByPeriodRequestSchema,
  options?: UseQueryOptions<
    NoticesAnalysisByPeriodQuery,
    unknown,
    NoticesAnalysisByPeriodQuery,
    QueryKey
  >,
) {
  const { data, ...rest } = useGraphQlQuery<
    NoticesAnalysisByPeriodQuery,
    {
      request: NoticesSearchRequest;
      byPeriodOptions: NoticesAnalysisByPeriodRequestSchema;
    }
  >(
    ["notices", searchNoticesRequest, byPeriodOptions],
    noticesAnalysisByPeriodQuery,
    [{ request: searchNoticesRequest, byPeriodOptions }],
    {
      ...REACT_QUERY_OPTIONS_NEVER_REFETCH,
      ...options,
    },
  );

  return {
    data: data?.notices,
    ...rest,
  };
}
